import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { CoreModule } from '../core/core.module';
import { CookieNgrxModule } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { ContentBlockContainerComponent } from './containers/content-block-container/content-block-container/content-block-container.component';
import { ContentBlockDefaultComponent } from './components/content-block-default/content-block-default.component';
import { ImageModule } from '@teamfoster/sdk/image';
import { ButtonModule } from '@teamfoster/sdk/button';
import { IconModule } from '@teamfoster/sdk/icon';
import { ContentBlockUspComponent } from './components/content-block-usp/content-block-usp.component';
import { ContentBlockPartnerComponent } from './components/content-block-partner/content-block-partner.component';
import { ContentBlockIntroductionComponent } from './components/content-block-introduction/content-block-introduction.component';
import { ContentBlockServiceComponent } from './components/content-block-service/content-block-service.component';
import { ContentBlockCaseComponent } from './components/content-block-case/content-block-case.component';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';

export const moduleExports = [ContentBlockContainerComponent];

import { register } from 'swiper/element/bundle';
import { BigTextComponent } from '../standalone/big-text/big-text.component';
import { InViewModule } from '@teamfoster/sdk/in-view';
import { ContentBlockCtaComponent } from './components/content-block-cta/content-block-cta.component';
import { ContentBlockQuestionComponent } from './components/content-block-question/content-block-question.component';
import { ContentBlockFeaturedComponent } from './components/content-block-featured/content-block-featured.component';
import { ContentBlockNavigationComponent } from './components/content-block-navigation/content-block-navigation.component';
import { ContentBlockCarrousselComponent } from './components/content-block-carroussel/content-block-carroussel.component';
import { ContentBlockTeamComponent } from './components/content-block-team/content-block-team.component';
import { TeamCardComponent } from '../standalone/team-card/team-card.component';
import { TextShapeComponent } from '../standalone/text-shape/text-shape.component';
import { workshopCardComponent } from '../standalone/workshop-card/workshop-card.component';
import SplittingDirective from '../animations/directives/splitting.directive';
import { ContentBlockWysiwygComponent } from './components/content-block-wysiwyg/content-block-wysiwyg.component';
import { ContentBlockMaasDefaultComponent } from './components/content-block-maas-default/content-block-maas-default.component';
import { ContentBlockContactComponent } from './components/content-block-contact/content-block-contact.component';
import { ContentBlockTeamv2Component } from './components/content-block-teamv2/content-block-teamv2.component';
import { ContentBlockPlayCtaComponent } from './components/content-block-play-cta/content-block-play-cta.component';
import { ContentBlockPlaySlideComponent } from './components/content-block-play-slide/content-block-play-slide.component';
import { ScrollIndicatorComponent } from '../standalone/scroll-indicator/scroll-indicator.component';
import { VideoComponent } from '../core/components/video/video.component';
import { ContentBlockPlayCtaEndComponent } from './components/content-block-play-cta-end/content-block-play-cta-end.component';
import { ContentBlockFullwidthImageComponent } from './components/content-block-fullwidth-image/content-block-fullwidth-image.component';
import { ContentBlockBaseComponent } from './components/content-block-base/content-block-base.component';

register();

@NgModule({
  declarations: [
    ...moduleExports,
    ContentBlockDefaultComponent,
    ContentBlockUspComponent,
    ContentBlockIntroductionComponent,
    ContentBlockCaseComponent,
    ContentBlockPartnerComponent,
    ContentBlockServiceComponent,
    ContentBlockCtaComponent,
    ContentBlockQuestionComponent,
    ContentBlockFeaturedComponent,
    ContentBlockNavigationComponent,
    ContentBlockCarrousselComponent,
    ContentBlockTeamComponent,
    ContentBlockWysiwygComponent,
    ContentBlockMaasDefaultComponent,
    ContentBlockContactComponent,
    ContentBlockTeamv2Component,
    ContentBlockPlayCtaComponent,
    ContentBlockPlaySlideComponent,
    ContentBlockPlayCtaEndComponent,
    ContentBlockFullwidthImageComponent,
    ContentBlockBaseComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TextUtilityModule,
    CoreModule,
    CookieNgrxModule,
    DictionaryNgrxModule,
    ImageModule,
    ButtonModule,
    IconModule,
    DynamicHooksModule,
    BigTextComponent,
    TeamCardComponent,
    InViewModule,
    TextShapeComponent,
    workshopCardComponent,
    SplittingDirective,
    ScrollIndicatorComponent,
    VideoComponent,
  ],
  exports: [...moduleExports],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContentBlocksModule {}
